export const GUIDE_LINKS = [
  {
    href: 'https://docs.bymason.com/setup-guide?utm_source=Controller&utm_medium=Referral',
    text: 'Getting started guide',
  },
  {
    href: 'https://docs.bymason.com/setup-guide#order-your-developer-kit',
    text: 'Set up your Dev Kit',
  },
  {
    href: 'https://docs.bymason.com/cli/installation',
    text: 'Download the Mason CLI',
  },
  {
    href: 'https://docs.bymason.com/how-to/manage-projects',
    text: 'About project creation',
  },
  {
    href: 'https://docs.bymason.com/how-to/manage-groups',
    text: 'About managing groups',
  },
  {
    href: 'https://docs.bymason.com/api/fleet',
    text: 'Learn about the Mason API',
  },
  {
    href: 'https://docs.bymason.com/mason-os/overview',
    text: 'Configuration glossary',
  },
  {
    href: 'https://docs.bymason.com/mason-os/release-notes/os6',
    text: 'Changelog',
  },
  {
    href: 'https://support.bymason.com/hc/en-us/sections/16154121152283-FAQ',
    text: 'FAQ',
  },
];
